export class AppConstants {
    public static DATE_DATABASE_FORMAT = 'YYYY-MM-DDTHH:mm';
    public static DATE_DISPLAY_FORMAT = 'dd/mm/yy';
    public static DATE_LITERAL_DISPLAY_FORMAT = 'DD, d MM yy';
    public static YEAR_RANGE = '2000:2030';
}

export class RegistrationSteps {
  public static PROFILE_DATA = "PROFILE_DATA";
  public static JOB_EXPERIENCE = "JOB_EXPERIENCE";
  public static COMPANY = "COMPANY";
  public static STUDY = "STUDY";
  public static CONCLUSION = "CONCLUSION";
}

export class RegistrationErrors {
  public static ERROR_PROFILE_DATA = 20001;
  public static ERROR_JOB_EXPERIENCE = 20002;
  public static ERROR_STUDY = 20003;
}
